import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { logout } from './../store/slices/authSlice'; 

export const createBaseQuery = (baseUrl: string): BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> => {
  const baseQuery = fetchBaseQuery({
    baseUrl: `${process.env.API_BASE_URL}/web/${baseUrl}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  });

  return async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    //  Handle session expiry (HTTP 440)
    if (result.error && result.error.status === 440) {
      console.warn('Session expired or unauthorized. Logging out...');

      try {
        // Optional logout API before clearing session
        await baseQuery({ url: 'logout', method: 'POST' }, api, extraOptions);
      } catch (err) {
        console.error('Logout API failed:', err);
      }

      // Clear browser storage
      localStorage.clear();

      //  Dispatch logout to Redux store
      api.dispatch(logout());

      // Redirect to login page
      window.location.href = '/login';
    }

    return result;
  };
};
